import { createFileRoute, redirect, useRouter } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { z } from 'zod';
import { AuditDetailView } from '../components/AuditDetailView';
import { Button } from '../components/ui/button';
import { getToken } from '../lib/api';

// 来源上下文：from = 来源审计列表的 linkId，fs = 来源筛选(audits search 的 JSON)。
// 用于「返回」时精确跳回原列表并还原选中态，不再依赖浏览器历史栈。
const auditDetailSearch = z.object({
  from: z.string().optional(),
  fs: z.string().optional(),
});

export const Route = createFileRoute('/audit/$id')({
  validateSearch: (s: Record<string, unknown>) => auditDetailSearch.parse(s),
  beforeLoad: () => {
    if (!getToken()) throw redirect({ to: '/login' });
  },
  component: AuditDetailPage,
});

function AuditDetailPage() {
  const { id } = Route.useParams();
  const { from, fs } = Route.useSearch();
  const router = useRouter();
  const navigate = Route.useNavigate();

  return (
    <div className="mx-auto max-w-4xl">
      <Button
        variant="ghost"
        size="sm"
        className="text-muted-foreground mb-4 -ml-2"
        onClick={() =>
          from
            ? navigate({
                to: '/audits/$linkId',
                params: { linkId: from },
                search: fs ? JSON.parse(fs) : {},
              })
            : router.history.back()
        }
      >
        <ArrowLeft /> 返回
      </Button>
      <AuditDetailView id={id} />
    </div>
  );
}
